import { render } from "./FormRoot.vue?vue&type=template&id=ed16fc5c"
import script from "./FormRoot.vue?vue&type=script&lang=ts"
export * from "./FormRoot.vue?vue&type=script&lang=ts"
script.render = render

export default script